// Core chat agent constants - all use chatAgent/ prefix for global state
export const TOGGLE_CHAT_AGENT = "chatAgent/TOGGLE_CHAT_AGENT";
export const SEND_MESSAGE_REQUEST = "chatAgent/SEND_MESSAGE_REQUEST";
export const SEND_MESSAGE_SUCCESS = "chatAgent/SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAILURE = "chatAgent/SEND_MESSAGE_FAILURE";
export const SEND_MESSAGE_CANCEL = "chatAgent/SEND_MESSAGE_CANCEL";
export const CLEAR_CHAT_HISTORY = "chatAgent/CLEAR_CHAT_HISTORY";
export const SET_CHAT_CONTEXT = "chatAgent/SET_CHAT_CONTEXT";
export const ADD_USER_MESSAGE = "chatAgent/ADD_USER_MESSAGE";

// Screen management - tracks which screen the chat is active on
export const SET_CURRENT_SCREEN = "chatAgent/SET_CURRENT_SCREEN";
export const SUPPORTED_SCREENS = ['brandPerformance', 'marketShare', 'skuTracker'];

// Independent filter fetching for chat templates
export const FETCH_CHAT_FILTERS_REQUEST = "chatAgent/FETCH_CHAT_FILTERS_REQUEST";
export const FETCH_CHAT_FILTERS_SUCCESS = "chatAgent/FETCH_CHAT_FILTERS_SUCCESS";
export const FETCH_CHAT_FILTERS_FAILURE = "chatAgent/FETCH_CHAT_FILTERS_FAILURE";

export const CREATE_CONVERSATION_REQUEST = "chatAgent/CREATE_CONVERSATION_REQUEST";
export const CREATE_CONVERSATION_SUCCESS = "chatAgent/CREATE_CONVERSATION_SUCCESS";
export const CREATE_CONVERSATION_FAILURE = "chatAgent/CREATE_CONVERSATION_FAILURE";

export const LOAD_CONVERSATIONS_REQUEST = "chatAgent/LOAD_CONVERSATIONS_REQUEST";
export const LOAD_CONVERSATIONS_SUCCESS = "chatAgent/LOAD_CONVERSATIONS_SUCCESS";
export const LOAD_CONVERSATIONS_FAILURE = "chatAgent/LOAD_CONVERSATIONS_FAILURE";

export const SWITCH_CONVERSATION = "chatAgent/SWITCH_CONVERSATION";

export const LOAD_CONVERSATION_DETAILS_REQUEST = "chatAgent/LOAD_CONVERSATION_DETAILS_REQUEST";
export const LOAD_CONVERSATION_DETAILS_SUCCESS = "chatAgent/LOAD_CONVERSATION_DETAILS_SUCCESS";
export const LOAD_CONVERSATION_DETAILS_FAILURE = "chatAgent/LOAD_CONVERSATION_DETAILS_FAILURE";

export const DELETE_CONVERSATION_REQUEST = "chatAgent/DELETE_CONVERSATION_REQUEST";
export const DELETE_CONVERSATION_SUCCESS = "chatAgent/DELETE_CONVERSATION_SUCCESS";
export const DELETE_CONVERSATION_FAILURE = "chatAgent/DELETE_CONVERSATION_FAILURE";
export const SET_LAST_EMPTY_CONVERSATION = "chatAgent/SET_LAST_EMPTY_CONVERSATION";

export const UPDATE_CONVERSATION_TITLE_REQUEST = "chatAgent/UPDATE_CONVERSATION_TITLE_REQUEST";
export const UPDATE_CONVERSATION_TITLE_SUCCESS = "chatAgent/UPDATE_CONVERSATION_TITLE_SUCCESS";
export const UPDATE_CONVERSATION_TITLE_FAILURE = "chatAgent/UPDATE_CONVERSATION_TITLE_FAILURE";

export const SET_ACTIVE_CONVERSATION = "chatAgent/SET_ACTIVE_CONVERSATION";

// Progress tracking constants
export const PROGRESS_UPDATE = "chatAgent/PROGRESS_UPDATE";
export const AGENT_MESSAGE_UPDATE = "chatAgent/AGENT_MESSAGE_UPDATE";
export const PIPELINE_START = "chatAgent/PIPELINE_START";
export const PIPELINE_COMPLETE = "chatAgent/PIPELINE_COMPLETE";
export const PIPELINE_ERROR = "chatAgent/PIPELINE_ERROR";
export const TITLE_UPDATED = "chatAgent/TITLE_UPDATED";
export const RESET_PROGRESS = "chatAgent/RESET_PROGRESS";
export const THINKING_STREAM = "chatAgent/THINKING_STREAM";

// Message feedback constants
export const UPDATE_MESSAGE_FEEDBACK = "chatAgent/UPDATE_MESSAGE_FEEDBACK";

// Category disambiguation picker constants
export const CATEGORY_SELECTION_SUBMITTED = "chatAgent/CATEGORY_SELECTION_SUBMITTED";
export const STORE_CATEGORY_SELECTION_REQUEST = "chatAgent/STORE_CATEGORY_SELECTION_REQUEST";
export const STORE_CATEGORY_SELECTION_SUCCESS = "chatAgent/STORE_CATEGORY_SELECTION_SUCCESS";
export const STORE_CATEGORY_SELECTION_FAILURE = "chatAgent/STORE_CATEGORY_SELECTION_FAILURE";

// Message regeneration constants
export const REGENERATE_MESSAGE_REQUEST = "chatAgent/REGENERATE_MESSAGE_REQUEST";
export const REGENERATE_MESSAGE_SUCCESS = "chatAgent/REGENERATE_MESSAGE_SUCCESS";
export const REGENERATE_MESSAGE_FAILURE = "chatAgent/REGENERATE_MESSAGE_FAILURE";
export const REMOVE_AGENT_MESSAGE = "chatAgent/REMOVE_AGENT_MESSAGE";

export const MESSAGE_TYPES = {
  USER: 'user',
  AGENT: 'agent',
  SYSTEM: 'system'
};
